module.exports = __webpack_public_path__ + "static/media/MO.057ae0a1.svg";